function sseevent(message: string): MessageEvent {
  let type = 'message',
    start = 0
  if (message.startsWith('event: ')) {
    start = message.indexOf('\n')
    type = message.slice(7, start)
  }
  start = message.indexOf(': ', start) + 2
  const data = message.slice(start, message.length)

  return new MessageEvent(type, { data })
}

interface XhrSourceOptions {
  method?: string
  headers: Record<string, string>
  body: string
  timeout?: number
  withCredentials?: boolean
}

export interface CloseableEventTarget extends EventTarget {
  close?: () => void
}

export function XhrSource(
  url: string,
  opts: XhrSourceOptions
): CloseableEventTarget {
  const eventTarget: CloseableEventTarget = new EventTarget()
  const xhr = new XMLHttpRequest()

  xhr.open(opts.method || 'GET', url, true)
  xhr.withCredentials = Boolean(opts.withCredentials)
  for (const k in opts.headers) {
    xhr.setRequestHeader(k, opts.headers[k])
  }

  let ongoing = false,
    start = 0
  xhr.onprogress = function () {
    if (!ongoing) {
      ongoing = true
      eventTarget.dispatchEvent(new Event('open'))
    }

    let i: number, chunk: string
    while ((i = xhr.response.indexOf('\n\n', start)) >= 0) {
      chunk = xhr.response.slice(start, i)
      start = i + 2
      if (chunk.length) {
        eventTarget.dispatchEvent(sseevent(chunk))
      }
    }
  }

  xhr.onload = () => {
    const doneMarker = '[DONE]\n'
    const lastIndex = xhr.response.lastIndexOf(doneMarker)
    if (lastIndex === -1) {
      eventTarget.dispatchEvent(
        new CloseEvent('error', { reason: 'No [DONE] marker found' })
      )
      return
    }
    // 抽取最后一个 "[DONE]\n" 之后的字符串
    const data = xhr.response.substring(lastIndex + doneMarker.length)
    eventTarget.dispatchEvent(new MessageEvent('complete', { data }))
    eventTarget.dispatchEvent(new CloseEvent('close', { reason: 'Done' }))
  }

  xhr.timeout = opts.timeout || 0
  xhr.ontimeout = () => {
    eventTarget.dispatchEvent(
      new CloseEvent('error', { reason: 'Network request timed out' })
    )
  }
  xhr.onerror = () => {
    eventTarget.dispatchEvent(
      new CloseEvent('error', {
        reason: xhr.response || 'Network request failed',
      })
    )
  }
  xhr.onabort = () => {
    eventTarget.dispatchEvent(
      new CloseEvent('error', { reason: 'Network request aborted' })
    )
  }

  eventTarget.close = () => {
    xhr.abort()
  }

  xhr.send(opts.body)
  return eventTarget
}
